const BASE_URL = process.env.REACT_APP_BASE_API;
export const resolveURL = url => {
  if (!url.includes('http')) return `${BASE_URL}${url}`;
  return url;
};
